<div class="card {$$props.class ?? ""}">
  <slot></slot>
</div>
